import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { toast } from "react-toastify";

export const ConfirmDeleteModal = ({
  show,
  setShow,
  onConfirm,
  loading = false,
  itemName = "item",
  message,
}) => {
  const handleConfirm = async () => {
    console.log("ConfirmDeleteModal: Delete button clicked, loading =", loading);
    try {
      await onConfirm(); // parent handles deletion logic
      console.log("ConfirmDeleteModal: Delete successful, closing modal");
      setShow(false); // Only close on success
    } catch (error) {
      console.error("ConfirmDeleteModal: Delete failed:", error);
      // Keep modal open on error so user can retry
      toast.error("Failed to delete. Please try again.", { theme: "colored" });
    }
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered size="sm">
      <div className="px-4 py-3" style={{ fontSize: "0.85rem" }}>
        <p className="mb-2 fw-bold">
          Confirm Delete
        </p>
        <div className="mt-0" style={{ fontSize: "0.85rem" }}>
          {message ||
            `Are you sure you want to delete this ${itemName}? This action cannot be undone.`}
        </div>

        <div className="d-flex align-items-center gap-2 mt-3">
          <Button
            size="sm"
            variant="secondary"
            style={{ fontSize: "0.85rem" }}
            onClick={() => setShow(false)}
          >
            Cancel
          </Button>

          {loading ? (
            <Spinner animation="border" size="sm" variant="success" />
          ) : (
            <Button
              size="sm"
              variant="danger"
              style={{ fontSize: "0.85rem" }}
              onClick={handleConfirm}
              disabled={loading}
            >
              Delete
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};
